const languageReducer = (state = 'pt-PT', action) => {
  switch(action.type){
    case 'CHANGE_LANGUAGE':
      return action.payload;
    default:
       return state;
  }
};

export default languageReducer;